module.exports = __webpack_public_path__ + "img/Twitter.83a04f2f.png";